// extracted by mini-css-extract-plugin
export default {"fixed":"mobile-screen-wrapper_fixed__5+g+h","wrapper":"mobile-screen-wrapper_wrapper__juNwz"};